import green from '@material-ui/core/colors/green';
import yellow from '@material-ui/core/colors/yellow';
import red from '@material-ui/core/colors/red';

export const error = red[500];
export const warning = yellow[500];
export const success = green[500];
